const rolesDev = [
  {
    _id: "6579b4ec1c63640013942369",
    role: "Coach",
  },
  {
    _id: "6579b5091c6364001394236a",
    role: "Admin",
  },
  {
    _id: "6579b5201c6364001394236b",
    role: "Owner",
  },
  {
    _id: "6579b5361c6364001394236c",
    role: "Nutritionist",
  },
];

const rolesProd = [
  {
    _id: "65c2446aaffe6200137c3462",
    role: "Coach",
  },
  {
    _id: "65c24484968bdb00135d847c",
    role: "Admin",
  },
  {
    _id: "65c2449526aae50014b271f2",
    role: "Owner",
  },
  {
    _id: "65c244aa26aae50014b271f3",
    role: "Nutritionist",
  },
];

const isNodeEnvProd = process.env.NODE_ENV === "production";

export const getOrganizationRoles = () => {
  if (isNodeEnvProd) return rolesProd;
  return rolesDev;
};
